import { toast } from 'react-toastify';

import { apiClient } from '@utils';

export const useGenerateInvitationUrl = () => {
  return apiClient.invitation.generateInvitationUrl.useMutation({
    onSuccess: () => {
      toast.success('Invitation URL generated successfully!');
    },
  });
};
